import React from "react";
import Title from "components/Title";
import AddNews from "./AddNews";

const TableHeader = () => {
  return (
    <div
      className="gx-d-flex gx-align-items-center gx-justify-content-between gx-mb-3"
      style={{ flexWrap: "wrap" }}
    >
      <Title title="news.pageTitle" />

      <AddNews />
    </div>
  );
};

export default TableHeader;
